import { promotionRulesThunk } from "./thunks";

import {
	setUsePromotionAction,
	setShowPromotionRulesAction,
	toggleShowPromotionRulesAction, setPromotionBets, pushPromotionBets
} from "./actions";
import { toggleFeedbackVisibilityAction } from "store/slices/common/actions.js";
import LocalStorageUtils from "utils/localStorage.js";

export const addUsePromotionCases = (builder) => {
	builder.addCase(setUsePromotionAction, (state, { payload }) => {
		state.usePromotion = payload.usePromotion;
	});
};

export const addSetPromotionBetsCases = (builder) => {
	builder.addCase(setPromotionBets, (state, { payload }) => {
		state.promotionBets.data = payload.promotionBets;
		state.promotionBets.isMulti = payload.isMulti;
		state.promotionBets.totalFactor = payload.totalFactor;
		state.promotionBets.possibleWin = payload.possibleWin;
	});

	builder.addCase(pushPromotionBets, (state, { payload }) => {
		state.promotionBets.data = [...state.promotionBets.data, ...payload.promotionBets];
	});
}

export const addPromotionRulesCases = (builder) => {
	builder.addCase(promotionRulesThunk.pending, (state) => {
		state.rules.isLoading = true;
	});

	builder.addCase(promotionRulesThunk.fulfilled, (state, { payload: data }) => {
		state.rules.isLoading = false;
		state.rules.data = data;
	});

	builder.addCase(promotionRulesThunk.rejected, (state, { error, meta: { arg } }) => {
		state.rules.isLoading = false;
	});

	builder.addCase(setShowPromotionRulesAction, (state, { payload }) => {
		state.rules.showRules = payload.showRules;
	});

	builder.addCase(toggleShowPromotionRulesAction, (state) => {
		state.rules.showRules = !state.showRules;
	});
};
